export const initialState = {
  message: null,
  isShowing: false,
}

export const SHOW_LOADING_UI_BLOCKER = 'shared/loadingUIBlocker/SHOW_LOADING_UI_BLOCKER'
export const showLoadingUIBlocker = ({ message, timeIn = 0, isShowing = true }) => ({
  type: SHOW_LOADING_UI_BLOCKER,
  payload: {
    message,
    timeIn,
    isShowing,
  },
})

export const REMOVE_LOADING_UI_BLOCKER = 'shared/loadingUIBlocker/REMOVE_LOADING_UI_BLOCKER'
export const removeLoadingUIBlocker = () => ({
  type: REMOVE_LOADING_UI_BLOCKER,
  payload: {
    message: null,
    isShowing: false,
  },
})

// SELECTORS
export const selectLoadingUIBlocker = state => state.application.loadingUIBlocker

// REDUCERS
const loadingUIBlocker = (state = initialState, { type, payload } = {}) =>
  ({
    [SHOW_LOADING_UI_BLOCKER]: (currentState, newPayload) => ({
      ...newPayload,
    }),
    [REMOVE_LOADING_UI_BLOCKER]: (currentState, newPayload) => ({
      ...newPayload,
    }),
  }[type]?.(state, payload) || state)

export default loadingUIBlocker
